import { render } from "./CustomerDetailSalesTab.vue?vue&type=template&id=915c24a4&scoped=true"
import script from "./CustomerDetailSalesTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailSalesTab.vue?vue&type=script&lang=js"

import "./CustomerDetailSalesTab.vue?vue&type=style&index=0&id=915c24a4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-915c24a4"]])

export default __exports__